/* La Maison Bleue â Custom Theme JS
   Upload to: assets/lmb.js in Shopify theme
   Then add before </body> in layout/theme.liquid:
   {{ 'lmb.js' | asset_url | script_tag }}
*/

document.addEventListener('DOMContentLoaded', function() {

  // ââ Nav scroll state ââ
  var nav = document.querySelector('.lmb-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('lmb-scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  // ââ Scroll-reveal observer ââ
  var revealEls = document.querySelectorAll('.lmb-reveal');
  if (revealEls.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('lmb-in');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    revealEls.forEach(function(el) { observer.observe(el); });
  }

  // ── Mobile hamburger menu ──
  var hamburger = document.getElementById('lmbHamburger');
  var mobileMenu = document.getElementById('lmbMobileMenu');
  var overlay = document.getElementById('lmbOverlay');
  var closeBtn = document.getElementById('lmbClose');

  function openMenu() {
    mobileMenu.classList.add('is-open');
    hamburger.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    hamburger.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (closeBtn)  closeBtn.addEventListener('click', closeMenu);
  if (overlay)   overlay.addEventListener('click', closeMenu);

  document.querySelectorAll('.lmb-mobile-link, .lmb-mobile-order').forEach(function(link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });

  // ââ Instagram Behold fallback ââ
  var feedId = document.querySelector('behold-widget');
  if (feedId && feedId.getAttribute('feed-id') !== 'YOUR_FEED_ID') {
    setTimeout(function() {
      var fallback = document.getElementById('lmbIgFallback');
      if (fallback) fallback.style.display = 'none';
    }, 2500);
  }

});
